export const styles = {
  containerPaddingX: { base: 8, md: 20 },
  containerPaddingY: { base: 8, md: 10 },
  cardContainerMaxW: { base: '100%', md: '562px' },
  cardPaddingX: { base: 8, md: 220 },
  cardPaddingY: { base: 8, md: 6 },
  continueButtonPaddingTop: { base: 8, md: 0 },
};
